import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../helpers/reducerRegistry'
import { getTotalSeperateCompanies } from './thunk'

const initialState = {
  totalPortfolios: 0,
  totalSeperateCompanies: 0,

  loading: {
    totalSeperateCompanies: true,
  },
}

const slice = createSlice({
  name: 'portfolio/summary/headerContent',
  initialState,
  reducers: {
    resetStore: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getTotalSeperateCompanies.pending, (state) => {
      state.loading.totalSeperateCompanies = true
    })
    builder.addCase(
      getTotalSeperateCompanies.fulfilled,
      (state, { payload }) => {
        state.totalPortfolios = payload?.totalPortfolios || 0
        state.totalSeperateCompanies = payload?.totalCompanies || 0
        state.loading.totalSeperateCompanies = false
      },
    )
    builder.addCase(getTotalSeperateCompanies.rejected, (state, action) => {
      state.loading.totalSeperateCompanies = action.payload.loading
    })
  },
})

export const selectTotalPortfolios = (state) =>
  state[slice.name].totalPortfolios
export const selectTotalSeperateCompanies = (state) =>
  state[slice.name].totalSeperateCompanies

export const selectLoading = (type) => (state) => {
  const loadingObj = state[slice.name].loading
  if (!type) return Object.values(loadingObj).some(Boolean)
  return loadingObj[type]
}

export const { resetStore } = slice.actions

register(slice.name, slice.reducer)
